import React, {Fragment} from 'react';
import Navbar from '../../components/Navbar'
import PageTitle from '../../components/pagetitle'
import ServiceSingle from '../../components/ServiceSingle'
import BookingForm from '../../components/BookingForm'
import Footer from '../../components/footer'
import Scrollbar from '../../components/scrollbar'
import { Helmet } from 'react-helmet';


const ServiceSinglePage =() => {
    return(
        <Fragment>
            <Helmet>
                <title>[Course Name] | Dar-ul-Quran Academy UK</title>
                <meta name="description" content="Learn more about our [Course Name] course. Expert tutors, flexible schedules, and a supportive environment for UK families." />
                <link rel="canonical" href="https://www.thedarulquran.com/[course-slug]" />
            </Helmet>
            <Navbar/>
            <PageTitle pageTitle={'Service'} pagesub={'Service'}/> 
            <ServiceSingle/>
            <BookingForm/>
            <Footer footerClass={'wpo-ne-footer-2'}/>
            <Scrollbar/>
        </Fragment>
    )
};
export default ServiceSinglePage;
